/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { defineMessages, useIntl } from 'react-intl'

import { createItem } from '@modules/utils/navigation'
import { connectedClustersURL } from '@modules/ccm-lib/urls'

import { isCCMFeatureActivated } from './feature'

const messages = defineMessages({
  connectedClusters: {
    id: `navigation.connected-clusters`,
    defaultMessage: `Connected clusters`,
  },
})

export function useConnectedClustersMenu() {
  const { formatMessage } = useIntl()

  if (!isCCMFeatureActivated()) {
    return []
  }

  return [
    createItem({
      'data-test-id': `ccm-link`,
      name: formatMessage(messages.connectedClusters),
      href: connectedClustersURL(),
      items: [],
    }),
  ]
}
